<template>
  <div class="template-detail-body">
    <div class="ccui-navigation" ref="navigation">
      <el-button
        size="mini"
        type="primary-icon-medium"
        icon="icon-ccui-return"
        @click="handleBack"
        >返回</el-button
      >
      <div class="ccui-navigation-divider" />
      <!-- 面包屑 -->
      <!-- <baseBreadCrumb :currBreadCrumb="currBreadCrumb"></baseBreadCrumb> -->
    </div>

    <div :class="detailDomStyle['style04']">
      <div class="detail-info">
        <div class="ccui-app-container-detail">
          <div class="ccui-app-container-detail-body">
            <div
              class="ccui-advanced-search-wrapper ccui-clearfix"
              ref="advancedSearchWrapper"
            >
              <el-card-title title="开标-开启"></el-card-title>
              <div class="pagetitle">
                （状态：<span style="color:red;">{{ baseForm.bidStatus }}</span
                >）
              </div>
              <div>
                <el-form
                  :model="baseForm"
                  ref="form"
                  label-width="120px"
                  class="ccui-form"
                  :inline="true"
                >
                  <el-row>
                    <el-col :span="10">
                      <el-form-item label="开标地点：">
                        {{ baseForm.bidPlace }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="7">
                      <el-form-item label="开标时间：">
                        {{ baseForm.bidDate }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="7">
                      <el-form-item
                        label="开标倒计时时间："
                        prop="procurementMethod"
                      >
                        <!-- 倒计时未开始 -->
                        {{ baseForm.bidTime }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
              <el-card-title title="开标人员"></el-card-title>
              <div class="pt20">
                <el-table
                  :data="peopleList"
                  border
                  style="width: 100%"
                  class="dic-sub-table-style01"
                >
                  <el-table-column
                    :show-overflow-tooltip="true"
                    type="index"
                    label="序号"
                    width="60"
                  />
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="participantName"
                    label="姓名"
                    width="180"
                  />
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="workUnitName"
                    label="工作单位"
                    width="180"
                  />
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="tel"
                    label="办公电话"
                  />
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="mobile"
                    label="手机"
                  />
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="email"
                    label="邮箱"
                  />
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="bidStatusStr"
                    label="是否开启"
                  />
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="operateTime"
                    label="开启时间"
                  />
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--底部功能按钮-->
    <el-bottom-guide>
      <ul class="ccui-bottom-button">
        <li>
          <el-button type="bottom" icon="icon-ccui-save-submit" @click="open"
            >开启</el-button
          >
        </li>
        <li>
          <el-button type="bottom" icon="el-icon-refresh-right" @click="refresh"
            >刷新</el-button
          >
        </li>
        <li>
          <el-button type="bottom" icon="icon-ccui-return" @click="handleBack"
            >返回</el-button
          >
        </li>
      </ul>
    </el-bottom-guide>
  </div>
</template>

<script>
import {
  queryApi,
  qryBidOpenDetail,
  queryTodomsgDetailById
} from "@/app/bidOpening/api/index.js";
import reqUrl from "@/app/bidOpening/api/taskPreparationUrl.js";
import { detailDomStyle } from "@/setting/setting";

export default {
  name: "bidOpeningOpera",
  components: {},
  props: {
    schemeParticipantId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      detailDomStyle: detailDomStyle,
      baseForm: {
        // bidStatus: this.$route.query.bidStatusStr, //状态
        bidStatus: "", //状态
        bidPlace: this.$route.query.openPlace, // 开标地点
        bidDate: this.$route.query.operateTime, // 开标时间
        bidTime: "" // 开标倒计时时间
      }, //开标信息
      peopleList: [], //开标人员
      todoData: "",
      todoId: this.$route.query.todoId,
      currBreadCrumb: {
        typeName: "查看",
        title: "标书开启-开启"
      },
      getSchemeParticipantId: "",
      url: new URL(window.location.href)
    };
  },
  watch: {},
  created() {},
  mounted() {
    if (this.schemeParticipantId) {
      this.getSchemeParticipantId = this.schemeParticipantId;
    }
    if (this.url.searchParams.has("todoId")) {
      // 从审批中心过来的，先通过todoid获取评标详情，然后直接进入评标室
      this.qryPurchaseList();
    } else {
      this.init();
      this.getDataInfo();
    }
  },
  activated() {},
  methods: {
    qryPurchaseList() {
      queryTodomsgDetailById({
        // userId: this.$route.query.wfUserId,
        id: this.todoId
      }).then(res => {
        if (res.data.code === "0") {
          this.todoData = res.data.data;
          this.getSchemeParticipantId = res.data.data.businessBillId;
          this.init();
          this.getDataInfo();
        }
      });
    },
    init() {
      let param = {
        schemeParticipantId: this.getSchemeParticipantId,
        isShowPageLoading: true
      };
      queryApi(reqUrl.qryBidOpenUserList, param).then(res => {
        if (res) {
          this.peopleList = res.data.data;
        }
      });
    },

    getDataInfo() {
      let param = {
        schemeParticipantId: this.getSchemeParticipantId
      };
      qryBidOpenDetail(param).then(res => {
        if (res.data.code === "0") {
          this.baseForm.bidDate = res.data.data.openTime;
          this.baseForm.bidPlace = res.data.data.openPlace;
          this.baseForm.bidStatus = res.data.data.openStatusStr;
          // this.schemeParticipantId = res.data.data.schemeParticipantId;
          this.getBidTime();
        }
      });
    },

    // 获取开标倒计时时间
    getBidTime() {
      if (this.baseForm.bidDate) {
        let dateBegin = new Date(this.baseForm.bidDate.replace(/-/g, "/")); //将-转化为/，使用new Date
        let dateEnd = new Date(); //获取当前时间
        let dateDiff = dateBegin.getTime() - dateEnd.getTime(); //时间差的毫秒数
        let dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)); //计算出相差天数
        let leave1 = dateDiff % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
        let hours = Math.floor(leave1 / (3600 * 1000)); //计算出小时数
        //计算相差分钟数
        let leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
        let minutes = Math.floor(leave2 / (60 * 1000)); //计算出分钟数
        //计算相差秒数
        var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
        var seconds = Math.round(leave3 / 1000); //计算出秒数
        if (dateDiff < 0) {
          this.baseForm.bidTime = "开标时间已到，可以开标！";
        } else {
          this.baseForm.bidTime =
            dayDiff + "天" + hours + "小时" + minutes + "分钟" + seconds + "秒";
        }
      } else {
        this.baseForm.bidTime = "";
      }
    },

    open() {
      this.$confirm("您是否确定开启？", "提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "ccui-message-box-custom"
      })
        .then(() => {
          let param = {
            schemeParticipantId: this.getSchemeParticipantId
            // schemeId: this.operaId
          };
          queryApi(reqUrl.dealTenderOpen, param).then(res => {
            if (res.data.code == "0") {
              this.$message({
                message: "您开标成功!",
                type: "success",
                duration: 3000,
                showClose: true,
                ccuiCustom: true
              });
              this.handleBack(true);
            }
          });
        })
        .catch(() => {});
    },
    refresh() {
      this.init();
      this.getDataInfo();
      // this.$nextTick(() => {
      //   this.$message({
      //     message: "刷新成功!",
      //     type: "success",
      //     duration: 3000,
      //     showClose: true,
      //     ccuiCustom: true
      //   });
      // });
    },
    handleBack(refresh) {
      if (this.url.searchParams.has("todoId")) {
        this.todoId = "";
        this.url.searchParams.delete("todoId");
        this.url.searchParams.delete("type");
        window.history.replaceState("", "", this.url);
        refresh = true;
        location.reload();
        return;
      }
      this.$emit("handleBack", refresh);
    }
  }
};
</script>

<style lang="scss" scoped>
.pagetitle {
  margin: 10px 0;
  font-size: 14px;
}
.app-container {
  background: none !important;
}
.fright {
  float: right;
}
.over-flow {
  overflow: auto;
}
.ccui-table-footer {
  margin-bottom: 20px;
}
/deep/ .el-table__fixed-right {
  height: auto;
}
.org-name {
  line-height: 18px;
}
.org-name span {
  font-size: 13px;
  color: #4a4a4a;
}
.org-full-name {
  line-height: 18px;
  margin-top: 5px;
  font-size: 13px;
  color: #999999;
  margin-left: 17px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.requestSeachParamsorg-icon {
  color: #0089ef;
  margin-right: 5px;
}
.icon-bottom-button {
  padding-right: 5px;
}
.ccui-form {
  /deep/ .el-form-item__content {
    max-width: calc(100% - 120px);
    overflow: hidden;
    word-break: break-all;
  }
}
</style>
